<template>
  <section class="single-cont">
    <table-component class="single-table"
                     :legend="createLegend()"
                     :columns="columns"
                     :all-checked="allSingleChecked"
                     :clearChecked="clearChecked"
                     @changeCheckbox="checkedRolesAll = $event"
                     @filterName="filterName($event)"
                     @checkAll="checkAll"
                     @filterTag="filterTag"
                     :column-width="columnWidth"></table-component>
  </section>
</template>

<script>
  import {mapState, mapMutations, mapGetters, mapActions} from 'vuex'
  import {tokenAndRoute} from "../../../mixins/utils/tokenAndRoute";
  import {filters} from "../../../mixins/filters";
  import userIcon from '../../Svg/users/user'
  import groupIcon from '../../Svg/cart_control/groupIcon'
  import delIcon from '../../Svg/cart_control/delIcon'
  import dotsIcon from '../../Svg/sidebar/dots'
  import gearIcon from '../../Svg/gearIcon'
  import {delItem} from "../../../mixins/delItem";
  import {loaderMixin} from "../../../mixins/utils/loaderMixin";
  import {toFormData} from "../../../mixins/utils/toFormData";
  import trimItem from '../../trimITem'

  import {tableComponentMixin} from "../../../mixins/utils/tableComponentMixin";

  export default {
    name: 'rolesSingle',
    props: {
      del: Boolean,
      isMother: {
        type: Boolean,
        default: true
      }
    },
    mixins: [tokenAndRoute, filters, delItem, loaderMixin, toFormData, tableComponentMixin],
    components: {
      userIcon,
      groupIcon,
      delIcon,
      dotsIcon,
      gearIcon,
      trimItem
    },
    data() {
      return {
        nameUp: true,
        nameDown: true,
        nameActive: false,

        //table
        legend: [],
        columnWidth: [
          (371/1070 * 100),
          (338/1070 * 100),
          (300/1070 * 100),
          0
        ],
        clearChecked: false,
      }
    },
    computed: {
      ...mapState({
        userData: state => state.auth.user,
        checkedRolesSingle: state => state.roles.checkedRoles,
        projects: state => state.projects.allProjects,
        activeRolesTags: state => state.roles.activeRolesTags,
        displayedRolesInCell: state => state.roles.displayedRolesInCell,
      }),
      ...mapGetters({
        singleItems: 'roles/interfaceSingleItems',
        //allSingleChecked: 'roles/allSingleChecked',
      }),
      checkedRolesAll: {
        get() {
          return this.checkedRolesSingle
        },
        set(val) {
          this.toggleCheckedRoles(val)
        }
      },
      allSingleChecked() {
        if (!this.checkedRolesSingle.length) return false;
        return this.checkedRolesSingle.length === this.columns.map(item => item.item).length
      },
      itemsInProject() {
        let projectId = this.$route.params.id;
        if (this.$route.name.includes('rolesInProjectItem')) {
          projectId = this.$route.params.item
        };


        let activeProject;
        let arr = [];

        let findActiveProject = () => {
          for (let project of this.projects) {
            if (projectId == project.id) {
              activeProject = project;
              break;
            };

            let findInner = (item) => {
              if (item.items) {
                for (let inner of item.items) {
                  if (inner.id == projectId) {
                    activeProject = inner;
                    break;
                    return;
                  };
                  findInner(inner)
                }
              }
            };

            findInner(project)
          }
        };
        findActiveProject();

        this.singleItems.forEach((singleItem) => {
          activeProject.permissions.forEach((activeProjectItem) => {
            if (singleItem.id === activeProjectItem.role_id) {
              arr.push(singleItem)
            }
          })
        })

        return arr;
      },
      rolesItems() {
        if (this.isMother) {
          return this.singleItems
        } else {
          return this.itemsInProject
        }
      },
      filteredRoles() {
        let arr = [];
        if (this.rolesItems) {
          arr = this.rolesItems.slice();

          if (this.nameActive) {
            arr.sort((a,b) => {
              let nameA = a.name;
              let nameB = b.name

              if (this.nameDown) {
                if (nameA < nameB) return -1;
                if (nameA > nameB) return 1;
                return 0
              }
              if (this.nameUp) {
                if (nameA < nameB) return 1;
                if (nameA > nameB) return -1;
                return 0
              }
            })
          }
        }
        return arr
      },
      columns() {
        let rolesArr = ((!this.activeRolesTags || this.activeRolesTags.length == 0) ? this.filteredRoles : this.filteredRoles.filter(item => {
          for(let i = 0; i < this.activeRolesTags.length; i++) {
            for (let x = 0; x < item.tags.length; x++) {
              if(item.tags[x].id == this.activeRolesTags[i].id) {
                return true;
              }
            }
          }

          return false;
        }));
        rolesArr = rolesArr.filter(item => item.deleted_at === null)

        this.setDisplayedRolesInCell(rolesArr) //понадобится в хедере ролей
        // console.log('rolesArr --->', rolesArr)
        return rolesArr.map(item => {
          return {
            id: item.id,
            item,
            cells: [
              {
                text: {
                  text: item.name,
                  isLink: true,
                  link: `roles/role/${item.id}`,
                  linkColor: false,
                  isTrimmed: true,
                  // trimWidth: 30
                  trimWidth: 1
                },
                avatar: {
                  isAvatar: false
                }
              },
              {
                text: {
                  text: ''
                },
                tagsArray: item.tags,
                avatar: {
                  isAvatar: false,
                }
              },
              {
                text: {
                  text: ''
                },
                usersArray: this.returnUsersData(item),
                avatar: {
                  isAvatar: false,
                }
              },
              {
                isGear: true,
                text: {
                  isLink: true,
                  text: '',
                  linkPrefix: '/roles/role/',
                  link: item.id
                },
                avatar: {
                  isAvatar: false,
                }
              }
            ]
          }
        })
      },

    },
    watch: {
      del(val) {
        if (val) {
          this.checkDel()
        }
      },
      checkedRolesSingle(val) {
        if (val.length === 0) {
          this.clearChecked = true;
          setTimeout(() => this.clearChecked = false, 100);
        }
      }
    },
    methods: {
      ...mapActions({
        getOwnedRoles: 'roles/getOwnedRoles',

        getUsers: 'roles/getUsers',
        deleteRole: 'roles/deleteRole',
        setRoleInGroup: 'roles/updateRole',

        updateSingleGrid: 'roles/updateGridSingle',
        updateGroupGrid: 'roles/updateGridGroup',
      }),
      ...mapMutations({
        toggleCheckedRoles: 'roles/TOGGLE_CHECKED_ROLES',
        setRolesActiveTags: 'roles/SET_ACTIVE_TAGS',
        setDisplayedRolesInCell: 'roles/SET_DISPLAYED_ROLES_IN_CELL'
      }),
      createLegend() {
        return this.legend = [
          {
            text: this.$t('popups.addRole.nameLb'),
            filterMethod: 'filterName',
            legendSort: true,
            legendDown: true,
            legendUp: true,
            activeFilter: false
          },
          {
            text: this.$t('roles.tags'),
            legendSort: false,
          },
          {
            text: this.$t('roles.roleUsersTite'),
            legendSort: false
          },

        ]
      },
      filterName(index) {
        this.copyLegend();
        this.setDefaultLegend();
        this.setActiveFilterLegend(index);

        this.nameActive = true;
        if (this.nameUp && this.nameDown) {
          this.nameDown = true;
          this.nameUp = false;
          this.setLegendDown(index);
          this.setLegendArr()
          return
        };

        if (this.nameUp) {
          this.nameDown = true
          this.nameUp = false;
          this.setLegendDown(index);
          this.setLegendArr()
          return
        }

        if (this.nameDown) {
          this.nameDown = false;
          this.nameUp = true;
          this.setLegendUp(index);
          this.setLegendArr()
          return
        }
      },
      filterTag(tag) {
        let active_tags = [];

        if(this.activeRolesTags && this.activeRolesTags.length > 0) {
          active_tags = this.activeRolesTags;
        }

        let active_tags_id = [];

        for (let i = 0; i < active_tags.length; i++) {
          active_tags_id.push(active_tags[i].id);
        }

        if(active_tags_id.indexOf(tag.id) != -1) {
          active_tags.splice(active_tags_id.indexOf(tag.id), 1);
        } else {
          active_tags.push(tag);
        }

        this.setRolesActiveTags(active_tags);
      },
      returnUsersData(item) {
        return item.users.map(item => {
          return {
            avatar: item.contacts.avatar_url,
            first_name: item.first_name,
            second_name: item.second_name
          }
        })
      },
      checkAll() {
        if (this.allSingleChecked) {
          this.toggleCheckedRoles([])
        } else {
          let allChecked = this.columns.map(item => {
            return item.item
          })
          this.toggleCheckedRoles(allChecked)
        }
      },
      goToRole(role)  {
        this.$router.push(`roles/role/${role.data.role.id}`)
      },

      deleteItems() {
        this.deleteRoles();
      },
      checkDel() {
        let string = '';
        this.checkedRolesSingle.forEach((item, i, arr) => {
          string += `${item.name}${(i !== arr.length - 1) ? ', ' : ''}`
        });

        this.showOverlay(true);
        this.showDelPopup(true);
        this.setDelItems(string);
      },
      async deleteRoles() {
        this.showLoader();
        for (let i = 0; i < this.checkedRolesSingle.length; i++) {
          let item = this.checkedRolesSingle[i];
          await this.deleteRole({token: this.token, id: item.id})
        };
        this.toggleCheckedRoles([]);
        this.clearChecked = true;

        setTimeout(() => {
            this.clearChecked = false;
          }, 100);

        this.hideLoader()
      },

    },
  }
</script>

<style lang="scss" scoped>
  .single-wrap {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 20px 0;
    user-select: none;
  }

  .single-cont {
    //width: 100%;
    //z-index: -1;
  }

  .single-table {
    padding-top: 15px;
  }
</style>
